'use strict';

import Loader from '../loader/loader';
import { isFieldSame, displayErrors } from '../../_assets/abbott/js/_helper';
import { toaster } from '../../_assets/abbott/js/_material';

export default class UpdatePassword {
    constructor() {
        let $body = $('body'),
            $updatePasswordDropdown = $('.update-password__dropdown'),
            $password = $('#UpdatePassword'),
            $verifyPassword = $('#UpdateVerifyPassword'),
            loader = new Loader(),
            dataParams = {};

        $('.js-expand-password').on('click', function (e) {
            e.preventDefault();

            $updatePasswordDropdown.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.addClass('fixed');
                }
            });
        });

        $('.js-update-password').on('click', function (e) {
            e.preventDefault();

            // Define where to display ajax errors
            let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

            if (isFieldSame($password, $verifyPassword)) {
                loader.fadeIn();

                dataParams = {
                    'Password' : $password.val()
                };

                $.ajax({
                    url: '/api/updatePassword',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    // type: 'POST',
                    data: JSON.stringify(dataParams),
                    success: function (data) {
                        toaster('Password has been saved!');

                        loader.fadeOut();

                        $errorContainer.slideUp({
                            duration: 500,
                            easing: 'easeInOutExpo',
                            queue: false
                        });

                        $password.val('');
                        $verifyPassword.val('');

                        $('.js-collapse-password').trigger('click');
                    },
                    error: function (error) {
          
                        loader.fadeOut();
                        displayErrors(error, $errorContainer );
                    }
                });
            } else {
                $password.parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                $verifyPassword.parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });
            }
        });
    }
}
